import React from "react";
import EditServiceUserContainer from "../../containers/EditServiceUserContainer/EditServiceUserContainer";

function EditServiceUserPage() {
  return <EditServiceUserContainer />;
}
export default EditServiceUserPage;
